module.exports = __webpack_public_path__ + "img/Maradona-8.996e03ac.webp";